import posthog from 'posthog-js';
import { ENVIRONMENT } from '../env';
import { isNative, getPlatform } from '../platform';

const isEnabled = () => ENVIRONMENT !== 'DEV';

/** Register platform info as super properties (sent with every event). */
export function registerPlatformProperties(): void {
  if (!isEnabled()) return;
  try {
    const platform = getPlatform();
    posthog.register({
      app_platform: platform,
      app_is_native: isNative(),
      app_environment: ENVIRONMENT,
    });
  } catch {
    // safe to ignore
  }
}

/** Capture a custom event. No-ops silently in DEV. */
export function trackEvent(
  event: string,
  properties?: Record<string, any>,
): void {
  if (!isEnabled()) return;
  try {
    posthog.capture(event, properties);
  } catch {
    // PostHog not ready — swallow silently
  }
}

/** Identify user with person properties. */
export function identifyUser(
  userId: string,
  properties?: Record<string, any>,
  propertiesSetOnce?: Record<string, any>,
): void {
  if (!isEnabled()) return;
  try {
    posthog.identify(userId, properties, propertiesSetOnce);
  } catch {
    // safe to ignore
  }
}

/** Reset PostHog (call on sign-out). */
export function resetAnalytics(): void {
  if (!isEnabled()) return;
  try {
    posthog.reset();
  } catch {
    // safe to ignore
  }
}

/** Set group for company-level analytics. */
export function setGroup(
  groupType: string,
  groupKey: string,
  groupProperties?: Record<string, any>,
): void {
  if (!isEnabled()) return;
  try {
    posthog.group(groupType, groupKey, groupProperties);
  } catch {
    // safe to ignore
  }
}
